import type { LinkComponentProps } from '@tanstack/react-router';
import type React from 'react';

import { isLinkProps } from '@/common/links';

import { Link } from './link';

export function List(props: React.ComponentPropsWithoutRef<'ul'>) {
  return (
    <ul
      role="list"
      className="divide-y divide-gray-100"
      {...props}
    />
  );
}

type StandaloneListItemProps = { standalone: true } & React.ComponentPropsWithoutRef<'div'>;
type LinkListItemProps = { to: LinkComponentProps['to']; standalone?: never } & LinkComponentProps;
type BasicLinkListItemProps = { to?: never; standalone?: never } & React.ComponentPropsWithoutRef<'li'>;

type ListItemProps = (
  | StandaloneListItemProps
  | LinkListItemProps
  | BasicLinkListItemProps
);

export function ListItem(props: ListItemProps) {
  if ('standalone' in props) {
    return (
      <div className="flex justify-start gap-x-4" {...props as StandaloneListItemProps} />
    );
  }

  if (isLinkProps(props)) {
    return (
      <li>
        <Link className="flex justify-start gap-x-6 gap-y-2 -mx-3 px-3 py-3 hover:bg-gray-100"{...props}/>
      </li>
    );
  }

  return (
    <li className="flex min-w-0 gap-x-4" {...props as BasicLinkListItemProps} />
  );
}

type ListItemTextProps = {
  primary: string;
  secondary: string;
};

export function ListItemText({ primary, secondary }: ListItemTextProps) {
  return (
    <div className="flex min-w-0 gap-x-4">
      <div className="min-w-0 flex-auto">
        <p className="text-base/6 font-semibold text-gray-900">{primary}</p>
        <p className="mt-1 truncate text-sm/5 text-gray-500">{secondary}</p>
      </div>
    </div>
  );
}
